module.exports = __webpack_public_path__ + "static/honeybee-logo-32df665d62c3673aa8d785ab5c686cc6.png";